import { inject, Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root'
})
export class MatIconRegistryService {

	private matIconRegistry = inject(MatIconRegistry)
	private domSanitizer = inject(DomSanitizer)

	icons = [
		{ name: 'dashboard', url: '../../../assets/icons/dashboard.svg' },
		{ name: 'media', url: '../../../assets/icons/media.svg' },
		{ name: 'categories', url: '../../../assets/icons/categories.svg' },
		{ name: 'courses', url: '../../../assets/icons/courses.svg' },
		{ name: 'favorite', url: '../../../assets/icons/favorite.svg' },
		{ name: 'my_notes', url: '../../../assets/icons/my_notes.svg' },
		{ name: 'edit', url: '../../../assets/icons/edit.svg' },
		{ name: 'play', url: '../../../assets/icons/play.svg' },
		{ name: 'delete', url: '../../../assets/icons/delete.svg' },
		{ name: 'download', url: '../../../assets/icons/download.svg' },
		{ name: 'pencil_simple', url: '../../../assets/icons/pencil_simple.svg' },
		{ name: 'copy', url: '../../../assets/icons/copy.svg' },
		{ name: 'check_circle', url: '../../../assets/icons/check_circle.svg' },
		{ name: 'close', url: '../../../assets/icons/close.svg' },
		{ name: 'category_courses', url: '../../../assets/icons/category_courses.svg' },
		{ name: 'check', url: '../../../assets/icons/check.svg' },
		{ name: 'plus', url: '../../../assets/icons/plus.svg' },
		{ name: 'calendar', url: '../../../assets/icons/calendar.svg' },
		{ name: 'language', url: '../../../assets/icons/language.svg' },
		{ name: 'three_dots', url: '../../../assets/icons/three_dots.svg' },
		{ name: 'drop_icon', url: '../../../assets/icons/drop_icon.svg' },
		{ name: 'book', url: '../../../assets/icons/book.svg' },
		{ name: 'clock', url: '../../../assets/icons/clock.svg' },
		{ name: 'favorite_filled', url: '../../../assets/icons/favorite_filled.svg' },
		{ name: 'upload_simple', url: '../../../assets/icons/upload_simple.svg' },
		{ name: 'person', url: '../../../assets/icons/person.svg' },
		{ name: 'visibility', url: '../../../assets/icons/visibility.svg' },
		{ name: 'sort_by', url: '../../../assets/icons/sort_by.svg' },
		{ name: 'chapter_favorite', url: '../../../assets/icons/chapter_favorite.svg' },
		{ name: 'chapter_drop_icon', url: '../../../assets/icons/chapter_drop_icon.svg' },
		{ name: 'quiz_interrogation', url: '../../../assets/icons/quiz_interrogation.svg' },
		{ name: 'locked_chapter', url: '../../../assets/icons/locked_chapter.svg' },
		{ name: 'dot', url: '../../../assets/icons/dot.svg' },
		{ name: 'arrow_up', url: '../../../assets/icons/arrow_up.svg' },
		{ name: 'check_rounded', url: '../../../assets/icons/check_rounded.svg' },
		{ name: 'warning_rounded', url: '../../../assets/icons/warning_rounded.svg' },
		{ name: 'draggable', url: '../../../assets/icons/draggable.svg' },
		{ name: 'tooltip_icon', url: '../../../assets/icons/tooltip_icon.svg' },
		{ name: 'plus_white', url: '../../../assets/icons/plus_white.svg' },
		{ name: 'info_error', url: '../../../assets/icons/info_error.svg' },
		{ name: 'visibility_off', url: '../../../assets/icons/visibility_off.svg' },
		{ name: 'breadcrumb_separator', url: '../../../assets/icons/breadcrumb_separator.svg' },
		{ name: 'world', url: '../../../assets/icons/world.svg' },
		{ name: 'world_black', url: '../../../assets/icons/world_black.svg' },
		{ name: 'export', url: '../../../assets/icons/export.svg' },
		{ name: 'check_answer', url: '../../../assets/icons/check_answer.svg' },
		{ name: 'wrong_answer', url: '../../../assets/icons/wrong_answer.svg' },
		{ name: 'warning', url: '../../../assets/icons/warning.svg' },
		{ name: 'category-courses', url: '../../../assets/icons/category-courses.svg' },
		{ name: 'arrow_down', url: '../../../assets/icons/arrow_down.svg' },
		{ name: 'upload_outlined', url: '../../../assets/icons/upload_outlined.svg' },
		{ name: 'upload_outlined_black', url: '../../../assets/icons/upload_outlined_black.svg' },
		{ name: 'book_closed', url: '../../../assets/icons/book_closed.svg' },
		{ name: 'logout', url: '../../../assets/icons/logout.svg' },
		{ name: 'courses-empty', url: '../../../assets/icons/courses-empty.svg' },
		{ name: 'close-grey', url: '../../../assets/icons/close-grey.svg' },
		{ name: 'error_rounded', url: '../../../assets/icons/error_rounded.svg' },
		{ name: 'info', url: '../../../assets/icons/info.svg' },
		{ name: 'notes_empty_state', url: '../../../assets/icons/notes_empty_state.svg' },
		{ name: 'vector', url: '../../../assets/icons/vector.svg' },
		{ name: 'red-cross', url: '../../../assets/icons/red-cross.svg' },
		{ name: 'search', url: '../../../assets/icons/search.svg' },
		{ name: 'window', url: '../../../assets/icons/window.svg' },
		{ name: 'list', url: '../../../assets/icons/list.svg' },
		{ name: 'delete_red', url: '../../../assets/icons/delete_red.svg' },
		{ name: 'course_completed', url: '../../../assets/icons/course_completed.svg' },
		{ name: 'finish_course-icon', url: '../../../assets/icons/finish_course-icon.svg' },
		{ name: 'close_black', url: '../../../assets/icons/close_black.svg' },
		{ name: 'three_lines', url: '../../../assets/icons/three_lines.svg' },
		{ name: 'plus_thin', url: '../../../assets/icons/plus_thin.svg' },
		{ name: 'tick_progress', url: '../../../assets/icons/tick_progress.svg' },
		{ name: 'check-big-grey', url: '../../../assets/icons/check-big-grey.svg' },
		{ name: 'tick_progress_orange', url: '../../../assets/icons/tick_progress_orange.svg' },
		{ name: 'tick_progress_green', url: '../../../assets/icons/tick_progress_green.svg' },
		{ name: 'clients', url: '../../../assets/icons/clients.svg' },
		{ name: 'envelope', url: '../../../assets/icons/envelope.svg' },
		{ name: 'play_white', url: '../../../assets/icons/play_white.svg' },
		{ name: 'manage_users', url: '../../../assets/icons/manage_users.svg' },
		{ name: 'inbox_icon', url: '../../../assets/icons/inbox_icon.svg' },
		{ name: 'resend_link', url: '../../../assets/icons/resend_link.svg' },
		{ name: 'arla_logo', url: '../../../assets/icons/ARLA_logo.svg' },
		{ name: 'padlock', url: '../../../assets/icons/padlock.svg' },
		{ name: 'webhook', url: '../../../assets/icons/webhook.svg' },
		{ name: 'arrow_left', url: '../../../assets/icons/arrow_left.svg' },
		{ name: 'arrow_left_fl', url: '../../../assets/icons/arrow_left_fl.svg' },
		{ name: 'arrow_right', url: '../../../assets/icons/arrow_right.svg' },
		{ name: 'arrow_right_fl', url: '../../../assets/icons/arrow_right_fl.svg' },
		{ name: 'diamond', url: '../../../assets/icons/diamond.svg' },
		{ name: 'lightning', url: '../../../assets/icons/lightning.svg' },
		{ name: 'medal', url: '../../../assets/icons/medal.svg' },
		{ name: 'mobile_device', url: '../../../assets/icons/mobile_device.svg' },
		{ name: 'shopping_cart', url: '../../../assets/icons/shopping_cart.svg' },
		{ name: 'lock', url: '../../../assets/icons/lock.svg' },
		{ name: 'visa', url: '../../../assets/icons/visa.svg' },
		{ name: 'mastercard', url: '../../../assets/icons/mastercard.svg' },
		{ name: 'american_express', url: '../../../assets/icons/american_express.svg' },
		{ name: 'discover', url: '../../../assets/icons/discover.svg' },
		{ name: 'currency_dollar', url: '../../../assets/icons/currency_dollar.svg' },
		{ name: 'trash', url: '../../../assets/icons/trash.svg' },
		{ name: 'cart', url: '../../../assets/icons/cart.svg' },
		{ name: 'check_done', url: '../../../assets/icons/check_done.svg' },
		{ name: 'warn_octagon', url: '../../../assets/icons/warn_octagon.svg' },
		{ name: 'circle', url: '../../../assets/icons/circle.svg' },
		{ name: 'zoom_in', url: '../../../assets/icons/zoom_in.svg' },
		{ name: 'zoom_out', url: '../../../assets/icons/zoom_out.svg' },
		{ name: 'file', url: '../../../assets/icons/file.svg' },
		{ name: 'image', url: '../../../assets/icons/image.svg' },
		{ name: 'check_icon_green', url: '../../../assets/icons/check_icon_green.svg' },
		{ name: 'support', url: '../../../assets/icons/support.svg' },
		{ name: 'support_light', url: '../../../assets/icons/support_light.svg' },
		{ name: 'ai', url: '../../../assets/icons/ai.svg' },
		{ name: 'refresh', url: '../../../assets/icons/refresh.svg' },
		{ name: 'message', url: '../../../assets/icons/message.svg' },

	];

	initializeIcons() {
		this.icons.map(icon => {
			this.matIconRegistry.addSvgIcon(
				`${icon.name}`,
				this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
			);
		});
	}

}
